import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'; // Importa los íconos que necesites
import './../css/components/Footer.css';

function Footer() {
  return (
    <footer className='footer'>
      <div className='footer__conos'></div>
      <div className='footer__redes'>
        <a href='https://www.facebook.com/lasdeliciasuy/?locale=es_LA' className='footer__redes__links'>
          <FontAwesomeIcon icon={faFacebook} /> lasdeliciasuy
        </a>
        <a href='https://www.instagram.com/las_delicias_uy/?hl=es' className='footer__redes__links'>
          <FontAwesomeIcon icon={faInstagram} /> las_delicias_uy
        </a>
      </div>
    </footer>
  );
}

export default Footer;
